import LensIcon from '@material-ui/icons/Lens';
import { Box, Divider, Grid, Paper, Typography } from '@mui/material';
import themev5 from 'src/themev5';

import { convertNumber, toCurrency } from '../../../../../utils/number';

interface PanelTitlesDebenturesProps {
  series?: string;
  emissionDate?: string;
  isin?: string;
  quantityIssued?: number;
  unitValue?: number;
  remuneration?: string;
}

function FieldRow({ label, value }: { label: string; value?: string }) {
  return (
    <Grid item xs={6}>
      <Box display="flex" alignItems="center">
        <LensIcon
          style={{
            fontSize: '0.6rem',
            color: '#FFCDA0',
            marginRight: themev5.spacing(1),
          }}
          titleAccess="ponto"
        />
        <Typography
          variant="body2"
          sx={(theme) => ({
            fontWeight: theme.typography.fontWeightBold,
          })}>
          {label}
        </Typography>
      </Box>
      <Typography
        variant="body2"
        sx={(theme) => ({
          paddingLeft: theme.spacing(2),
          [theme.breakpoints.down('xs')]: {
            paddingLeft: 0,
          },
        })}>
        {value ?? 'N/D'}
      </Typography>
    </Grid>
  );
}

export default function PanelTitlesDebentures({
  series,
  emissionDate,
  isin,
  quantityIssued,
  unitValue,
  remuneration,
}: PanelTitlesDebenturesProps) {
  const quantityDisplay =
    quantityIssued != null && !Number.isNaN(quantityIssued)
      ? convertNumber(quantityIssued)
      : 'N/D';

  const unitValueDisplay =
    unitValue != null && !Number.isNaN(unitValue)
      ? toCurrency(unitValue)
      : 'N/D';

  return (
    <Box my={2} mx={1} display="flex" alignItems="center">
      <Box
        position="absolute"
        alignItems="center"
        height={55}
        sx={(theme) => ({
          borderLeft: `6px solid ${theme.palette.secondary.main}`,
        })}
      />
      <Paper
        elevation={6}
        square
        sx={(theme) => ({
          marginLeft: 3,
          padding: theme.spacing(3, 1),
          width: 350,
          [theme.breakpoints.down('xs')]: {
            width: 270,
            minHeight: 230,
          },
        })}>
        <Box p={1}>
          <Grid container>
            <FieldRow label="Série" value={series} />
            <FieldRow label="Data de Emissão" value={emissionDate} />
          </Grid>
        </Box>
        <Divider />
        <Box p={1}>
          <Grid container>
            <FieldRow label="ISIN" value={isin} />
            <FieldRow label="Qtd Emitida" value={quantityDisplay} />
          </Grid>
        </Box>
        <Divider />
        <Box p={1}>
          <Grid container>
            <FieldRow label="Valor Nominal" value={unitValueDisplay} />
            <FieldRow label="Rentabilidade" value={remuneration} />
          </Grid>
        </Box>
      </Paper>
    </Box>
  );
}
